import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { useSiteContent } from "@/i18n/SiteContentContext";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2.2,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <span ref={ref} className="font-jakarta text-5xl font-extrabold text-white md:text-7xl">
      {display.toLocaleString()}
      <span className="text-gold">{suffix}</span>
    </span>
  );
};

export const Stats = () => {
  const { get } = useSiteContent();
  const s = get("stats", null);
  const stats = [
    { value: s?.experience ?? 20, suffix: "+", label: "Years Experience" },
    { value: s?.fleet ?? 100, suffix: "+", label: "Fleet Vehicles" },
    { value: s?.employees ?? 200, suffix: "+", label: "Employees" },
    { value: s?.deliveries ?? 5000, suffix: "+", label: "Deliveries" },
  ];
  return (
  <section id="stats" data-testid="stats-section" className="honeycomb-bg-light relative overflow-hidden bg-royal py-24 md:py-32">
    <div className="pointer-events-none absolute -left-32 top-0 h-80 w-80 rounded-full bg-gold/10 blur-3xl" />
    <div className="pointer-events-none absolute -right-32 bottom-0 h-80 w-80 rounded-full bg-sky/10 blur-3xl" />
    <div className="relative mx-auto grid max-w-6xl grid-cols-2 gap-12 px-6 text-center md:grid-cols-4 lg:px-10">
      {stats.map((s, i) => (
        <div key={s.label} data-testid={`stat-${i}`}>
          <Counter value={s.value} suffix={s.suffix} />
          <p className="mt-3 text-xs font-bold uppercase tracking-[0.25em] text-sky/80">{s.label}</p>
        </div>
      ))}
    </div>
  </section>
  );
};